import { render, staticRenderFns } from "./VPadlock.vue?vue&type=template&id=b06b9b92&"
import script from "./VPadlock.vue?vue&type=script&lang=js&"
export * from "./VPadlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports